import React from "react";

const ClockStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.25 17.5C14.2541 17.5 17.5 14.2541 17.5 10.25C17.5 6.24594 14.2541 3 10.25 3C6.24594 3 3 6.24594 3 10.25C3 14.2541 6.24594 17.5 10.25 17.5Z",
  stroke: "currentColor",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.25 6.25V10.25L12.25 12.25",
  stroke: "#E6E6E6",
  strokeWidth: 1.5
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ClockStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;